import React, { Component } from 'react';
import Col from 'react-bootstrap/Col'

export default class Poster extends Component {

    constructor(props) {
        super(props);

        this.loaded = false;

        this.state = {
            i: props.i,
            id: props.id,
            url: props.url,
            author: props.author,
            title: props.title,
            country: props.country,
            website: props.website,
            active: props.active,
            fullInfo: props.fullInfo,
            fullInfoActive: props.fullInfoActive
        };

        /*this.pathDev = 'https://eden.dei.uc.pt/~srebelo/dev/';*/ /*FIXME*/
    }

    openFullInfo = () => {
        //this.state.fullInfo.current.update(this.state.i);
        this.state.fullInfo.current.open(this.state.i);
    }

    isLoaded = () => {
        this.loaded = true;
    }

    render() {
        return (
            <Col className="poster-container-outer" id={"poster-"+this.state.id} xs={6} s={3} md={4}>
                {this.state.active &&
                    <div
                        className={this.state.active ? 'poster-container-inner poster-active' : 'poster-container-inner poster-not-released'}>
                        <img
                            src={this.state.url}
                            alt={`Poster ${this.state.title} designed by ${this.state.author}`}
                            onClick={this.state.fullInfoActive ? this.openFullInfo : null }
                            className={this.state.fullInfoActive ? 'fullInfoActive' : 'fullInfoNotActive' }
                            onLoad={this.isLoaded}
                        />
                        {/*<div className="poster-info-bg"/>*/}
                        <div className="poster-short-info p-5">
                            <h3>{this.state.title}</h3>
                            <p>
                                <span>{`${this.state.author} `}</span>
                                <span className="text-uppercase">{`(${this.state.country})`}</span>
                            </p>
                        </div>
                    </div>
                }
            </Col>
        )
    }
}